import { Collapes } from 'bootstrap'
import productFilters from './ml-scripts/product-filters'
import VideoModal from './ml-scripts/video-modal'
import HeroCarousel from './ml-scripts/hero-carousel';
import Marquee from './app/global-marquee';
import CountdownTimer from './app/global-countdown-timer';
import InitGiftNotes from './app/global-gift-note';
VideoModal();
HeroCarousel();
Marquee();
CountdownTimer();
InitGiftNotes({ selector: '[gift-note]'})
document.addEventListener('DOMContentLoaded', () => {
  productFilters()
})